import script from "./ForgotPasswordComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordComponent.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordComponent.vue?vue&type=style&index=0&id=2a7d6021&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a7d6021"]])

export default __exports__